const CURRENT_VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? null;
const POLL_INTERVAL_MS = 5 * 60 * 1000;

let reloadScheduled = false;

function reloadOnce(): void {
  if (reloadScheduled) return;
  reloadScheduled = true;
  window.location.reload();
}

async function fetchRemoteVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
      headers: {Accept: 'application/json'},
    });
    if (!res.ok) return null;
    const data = (await res.json()) as {version?: string};
    return data.version ?? null;
  } catch {
    return null;
  }
}

async function checkVersion(): Promise<void> {
  if (reloadScheduled || !CURRENT_VERSION) return;
  const remote = await fetchRemoteVersion();
  if (remote && remote !== CURRENT_VERSION) reloadOnce();
}

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk \S+ failed/i,
  /ChunkLoadError/i,
];

function looksLikeStaleChunk(message: string | undefined): boolean {
  if (!message) return false;
  return CHUNK_ERROR_PATTERNS.some((re) => re.test(message));
}

export function setupVersionCheck(): void {
  void checkVersion();

  setInterval(() => {
    void checkVersion();
  }, POLL_INTERVAL_MS);

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) void checkVersion();
  });

  window.addEventListener('error', (event) => {
    if (looksLikeStaleChunk(event.message)) reloadOnce();
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason as {message?: string} | string | undefined;
    const message = typeof reason === 'string' ? reason : reason?.message;
    if (looksLikeStaleChunk(message)) reloadOnce();
  });
}
